import themes from './themes';
import assets from './assets';
import setup from './setup';

export default {
  themes,
  assets,
  setup
}
